/**
 * Canonical attendance status → label + badge classes.
 * Kept in ONE place so the admin and employee views stay in lock-step;
 * the previous bug was the employee page inlining its own 3-branch conditional
 * which made `absent` render green (default emerald fallback).
 * Must stay aligned with the backend ATTENDANCE_STATUSES enum in `routes/hr.py`.
 */
export const ATTENDANCE_STATUS_CONFIG = {
  present:             { label: 'Present',           cls: 'bg-emerald-500/10 text-emerald-500' },
  absent:              { label: 'Absent',            cls: 'bg-red-500/10 text-red-500' },
  paid_leave:          { label: 'Paid Leave',        cls: 'bg-blue-500/10 text-blue-500' },
  unpaid_leave:        { label: 'Unpaid Leave',      cls: 'bg-orange-500/10 text-orange-500' },
  half_day_paid_leave: { label: 'Half-Day (Paid)',   cls: 'bg-purple-500/10 text-purple-500' },
  holiday:             { label: 'Holiday',           cls: 'bg-indigo-500/10 text-indigo-500' },
  weekly_off:          { label: 'Weekly Off',        cls: 'bg-zinc-500/10 text-zinc-500' },
  // Legacy values kept for backwards-compat with already-migrated rows
  late:                { label: 'Late',              cls: 'bg-amber-500/10 text-amber-500' },
  on_leave:            { label: 'On Leave',          cls: 'bg-blue-500/10 text-blue-500' },
  half_day:            { label: 'Half-Day',          cls: 'bg-purple-500/10 text-purple-500' },
};

/**
 * Resolve a row's display badge, honouring the two "virtual" flags
 * (`is_holiday`, `is_weekend`) that some upstream services set instead of
 * writing an explicit status. Returns { label, cls }.
 */
export const resolveAttendanceBadge = (row) => {
  if (row?.is_holiday) {
    return {
      label: row.holiday_name ? `Holiday (${row.holiday_name})` : 'Holiday',
      cls: ATTENDANCE_STATUS_CONFIG.holiday.cls,
    };
  }
  if (row?.is_weekend && row?.status !== 'present') {
    // The row was pre-marked as a weekly-off day — show the weekly-off badge
    // unless the employee actually checked in that day (some ops do that).
    return ATTENDANCE_STATUS_CONFIG.weekly_off;
  }
  return ATTENDANCE_STATUS_CONFIG[row?.status] || {
    label: row?.status || '-',
    cls: 'bg-muted text-muted-foreground',
  };
};
